<template>
  <div class="card p-3 mb-4">
    <div class="row g-3">

      <!-- Cognome -->
      <div class="col-md-4">
        <label class="form-label fw-bold">Cognome</label>
        <input type="text" class="form-control" v-model="surname" placeholder="Cognome" />
      </div>

      <!-- Nome -->
      <div class="col-md-4">
        <label class="form-label fw-bold">Nome</label>
        <input type="text" class="form-control" v-model="name" placeholder="Nome" />
      </div>

      <div class="col-md-4 d-flex align-items-end">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="onlyInactive" v-model="onlyInactive" />
          <label class="form-check-label" for="onlyInactive">
            Solo utenti non attivi
          </label>
        </div>
      </div>

      <!-- Ruolo -->
      <!--<div class="col-md-4">
        <label class="form-label fw-bold">Ruolo</label>
        <div class="dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" type="button"
            data-bs-toggle="dropdown">
            {{ selectedRolesLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height:200px; overflow-y:auto;">
            <li v-for="role in allRoles" :key="role.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="role.id" v-model="roleIds"
                id="role-{{role.id}}" />
              <label class="form-check-label ms-2" :for="'role-' + role.id">{{ role.description }}</label>
            </li>
          </ul>
        </div>
      </div>-->

    </div>

    <!-- Pulsanti -->
    <div class="row mt-3">
      <div class="col text-end">
        <button class="btn btn-outline-secondary me-2" @click="resetFilters">
          <i class="bi bi-x"></i> Reset
        </button>
        <button class="btn btn-outline-primary" @click="applyFilters">
          <i class="bi bi-search"></i> Cerca
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserFilters',
  props: {
    allRoles: { type: Array, required: true }
  },
  emits: ['filter'],
  data() {
    return {
      name: '',
      surname: '',
      roleIds: [],
      onlyInactive: false
    }
  },
  methods: {
    applyFilters() {
      this.$emit('filter', {
        name: this.name,
        surname: this.surname,
        role_ids: this.roleIds,
        onlyInactive: this.onlyInactive
      });
    },
    resetFilters() {
      this.name = '';
      this.surname = '';
      this.roleIds = [];
      this.$nextTick(() => this.applyFilters());
    }
  }
}
</script>
